export enum SearchButton {
  ALL = "",
  ONLINE = "Online",
  OFFLINE = "Offline",
  WARNING = "Warning",
}
